import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from '@growdash/design-system/molecules';
import { AuthModernCompactLayout } from '../../layouts';
// paths
import AuthGuard from '@hocs/auth-guard';
import { paths } from '../paths';

// Pages
const OnboardingPage = lazy(() => import('@pages/onboarding/index'));

const onboarding = {
  path: '',
  element: (
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: paths.pricing.root,
      element: (
        <AuthGuard>
          <AuthModernCompactLayout>
            <OnboardingPage />
          </AuthModernCompactLayout>
        </AuthGuard>
      )
    }
  ]
};

export const onboardingRoutes = [
  {
    path: '',
    children: [onboarding]
  }
];
